import { useMutation } from 'react-query';

import listedkitService from 'resources/listedkit/listedkit.service';

export default function useListedKitExists() {
  return useMutation(
    async ({ name }) => listedkitService.isListedKitExists({ name }),
  );
}
